import { ChangeDetectorRef, Input, Component, OnInit } from '@angular/core';

@Component({
    selector: 'tooltip',
    templateUrl: './tooltip.component.html',
    host: {
        '(document:click)': 'docClick($event)',
    }
})
export class TooltipComponent implements OnInit {
    @Input() trigger: string = '';
    @Input() title: string = '';
    @Input() content: string = '';
    @Input() minScore: number = null;
    @Input() maxScore: number = null;
    @Input() forceShow: boolean = false;
    @Input() watchHostInitial: boolean = true;

    public active: boolean = this.forceShow;

    constructor() {}

    ngOnInit() {
        this.active = this.forceShow;
        setTimeout(()=>{
            this.watchHostInitial = true;
        },200);
    }

    doClick(event)
    {
        if(event.srcElement.tagName != 'A')
        {
            this.active = !this.active;
        }
    }

    docClick(event)
    {
        if(this.watchHostInitial && !event.path.find((elem) => {
            return elem.tagName == 'TOOLTIP';
        }))
        {
            this.active = false;
        }
    }

}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/_blocks/tooltip/tooltip.component.ts